import queryString from "query-string";
import { useDispatch, useSelector } from "react-redux";
import {
  updateZipCodeValue,
  updateZipFilterData,
  updateIsZipSubmitted
} from "../store/slices/zipInfo";
import { INSIGHTS_TYPE } from "../templates/strings";
import { updateRecordActionState } from "../store/slices/funnelInfo";
import { isValidPostalCode, getPostalCodeLengths } from "../services/utils";
import {
  checkPostalCode,
  fetchWorkspaceForGlobalThankyou,
  recordBlockedPostalCode
} from "../services/api";
import {
  enableReclaimMode,
  updateReclaimModeConfig
} from "../store/slices/reclaimMode";
import {
  captureGoogleAdsAttribution,
  isGoogleAdsVisit,
  metaAdDetailsFromParams
} from "../services/googleAdsAttribution";

export const useZipcodeAction = () => {
  const dispatch = useDispatch();
  const { funnel, qResponses } = useSelector((state) => state.funnelInfo);
  const zipInfo = useSelector((state) => state.zipInfo);
  const countryOption = useSelector(
    (state) => state.countryOption.countryOption
  );
  const postalCodeLengths = getPostalCodeLengths(countryOption);
  // Map of the funnel's country; a legacy key without a loaded option uses the bundled map
  const mapImageSrc = countryOption?.mapImageUrl
    ? `${process.env.REACT_APP_ASSET_CDN_URL}/${countryOption.mapImageUrl}`
    : "";
  const isPostalCodeValid = isValidPostalCode(zipInfo.value, postalCodeLengths);
  // Digits only, cut at the longest postal code of the funnel's countries
  const handleUpdateZip = ({ value }) =>
    dispatch(
      updateZipCodeValue(
        value.replace(/\D/g, "").slice(0, Math.max(...postalCodeLengths))
      )
    );

  const handleZipcodeSubmit = () => {
    const nextInsight = funnel.textElements.enablePhoneWithTwoSteps
      ? INSIGHTS_TYPE.LEAD_STEP_ONE
      : INSIGHTS_TYPE.LEAD;
    dispatch(updateIsZipSubmitted(!zipInfo.isSubmitted));

    dispatch(
      updateRecordActionState({
        insightRefId: INSIGHTS_TYPE.ZIP,
        insightType: INSIGHTS_TYPE.ZIP,
        nextInsightRefId: nextInsight,
        nextInsightType: nextInsight
      })
    );

    dispatch(updateZipCodeValue(zipInfo.value));
  };
  const handleCheckZipcode = async () => {
    try {
      const response = await checkPostalCode(funnel.id, zipInfo.value);
      const data = response.data.data;
      try {
        if (!data.shouldCreate) {
          const searchParams = queryString.parse(window.location.search);
          const fbClId = searchParams.fbclid;
          // Keep TikTok click id when a lead is blocked by postal code.
          const ttclid = searchParams.ttclid || localStorage.getItem("ttclid");
          const dynamicSource = searchParams.source?.toLowerCase();
          const testMode = searchParams.testMode === "true" ? true : false;
          const leadPayload = {
            clickId: fbClId,
            fbc: localStorage.getItem("fbc"),
            ttclid,
            testMode,
            lead: {
              funnelId: funnel._id,
              leadDetails: {
                leadZip: zipInfo.value
              },
              // am_* values of a Google Ads visit are no Meta ad details
              ...(isGoogleAdsVisit({
                attribution: captureGoogleAdsAttribution()
              })
                ? {}
                : { adDetails: metaAdDetailsFromParams(searchParams) }),
              responses: qResponses,
              source: dynamicSource,
              sourceUrl: window.location.href,
              policyVersion: undefined,
              submittedAt: new Date().toISOString()
            }
          };
          await recordBlockedPostalCode(leadPayload);
          if (funnel.reclaimMode && funnel.general.funnelType === "LEAD") {
            dispatch(enableReclaimMode());
            try {
              (async function () {
                const thankyouResponse =
                  await fetchWorkspaceForGlobalThankyou();
                const { globalReclaimConfig } = thankyouResponse.data.data;
                dispatch(updateReclaimModeConfig(globalReclaimConfig));
              })();
            } catch (error) {
              console.log("Error in fetching reclaim thankyou page", error);
            }
          }
        }
      } catch (e) {
        console.log(e);
      }

      dispatch(updateZipFilterData(data));
    } catch (error) {
      console.log("error", error);
    }
  };

  return {
    handleUpdateZip,
    postalCodeLengths,
    isPostalCodeValid,
    mapImageSrc,
    handleCheckZipcode,
    handleZipcodeSubmit
  };
};
